export interface Category {
  key: string;
  name: string;
  icon: string;
  description: string;
}

export interface Special {
  id: string;
  title: string;
  cover: string;
  intro: string;
  reason: string;
  videoIds: string[];
}

export interface Video {
  id: string;
  title: string;
  cover: string;
  heroCover?: string;
  duration: string;
  uploadedAt: string;
  categoryKey: string;
  region: string;
  year: number;
  type: string;
  views: number;
  favorites: number;
  description: string;
  source: string;
  tags: string[];
  specialIds: string[];
}

export const categories: Category[] = [
  {
    key: "film",
    name: "影视剪辑",
    icon: "ri-film-line",
    description:
      "精选影视作品中的经典亲吻片段，从浪漫爱情片到文艺电影，收录银幕上最动人的瞬间。",
  },
  {
    key: "short",
    name: "短视频",
    icon: "ri-video-line",
    description:
      "时长精简、节奏轻快的亲吻短视频合集，适合碎片时间快速浏览与发现。",
  },
  {
    key: "emotional",
    name: "情感专辑",
    icon: "ri-heart-3-line",
    description:
      "以情感故事为主线的亲吻主题作品，围绕告白、重逢与陪伴等温暖叙事展开。",
  },
];

export const regionOptions = ["全部", "中国", "欧美", "日本", "韩国"];
export const yearOptions = ["全部", "近1年", "近3年", "10年内"];
export const typeOptions = ["全部", "长片剪辑", "短片"];
export const sortOptions = ["最新上传", "播放量", "收藏热度"];

export const categoryNameMap: Record<string, string> = {
  film: "影视剪辑",
  short: "短视频",
  emotional: "情感专辑",
};

export const videos: Video[] = [
  {
    id: "v1",
    title: "黄昏花田里的初吻",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20cinematic%20film%20still%20of%20a%20couple%20embracing%20under%20warm%20golden%20sunset%20light%20in%20a%20flower%20field%2C%20soft%20bokeh%20background%2C%20elegant%20editorial%20photography%2C%20warm%20rose%20tones%2C%20dreamy%20atmosphere&width=640&height=360&seq=qz-v1&orientation=landscape",
    heroCover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20romantic%20couple%20silhouette%20embracing%20in%20a%20golden%20sunset%20flower%20field%2C%20warm%20amber%20and%20rose%20light%2C%20soft%20haze%2C%20artistic%20film%20grade%2C%20deep%20shadow%20contrast%20for%20text%20overlay&width=1920&height=820&seq=qz-hero1&orientation=landscape",
    duration: "04:12",
    uploadedAt: "2026-09-28",
    categoryKey: "film",
    region: "欧美",
    year: 2026,
    type: "长片剪辑",
    views: 128600,
    favorites: 8420,
    description:
      "选自一部田园爱情电影的高光片段：男女主角在黄昏的花田里终于坦白心意，随风起伏的花丛与渐暗的霞光把这一刻烘托得格外温柔。全片用长镜头记录了从对视到靠近的完整过程。",
    source: "《花田叙曲》片段精选",
    tags: ["黄昏", "初吻", "田园", "长镜头"],
    specialIds: ["s1", "s3"],
  },
  {
    id: "v2",
    title: "雨夜车站的告别之吻",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20cinematic%20scene%20of%20a%20couple%20kissing%20under%20a%20streetlamp%20in%20the%20rain%20at%20a%20train%20station%20platform%2C%20reflective%20wet%20ground%2C%20soft%20warm%20lamplight%2C%20blue%20gray%20night%20tones%20with%20warm%20highlights%2C%20film%20still%20photography&width=640&height=360&seq=qz-v2&orientation=landscape",
    duration: "05:36",
    uploadedAt: "2026-09-20",
    categoryKey: "film",
    region: "韩国",
    year: 2025,
    type: "长片剪辑",
    views: 98450,
    favorites: 6110,
    description:
      "一场雨中的告别：即将远行的两人在站台灯下留下了最后一个吻。雨声、汽笛与闪烁的车灯交织，情绪的克制让这一幕更具冲击力。",
    source: "《末班车以前》片段精选",
    tags: ["雨夜", "告别", "车站", "催泪"],
    specialIds: ["s2"],
  },
  {
    id: "v3",
    title: "厨房里的清晨一吻",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20cozy%20kitchen%20morning%20scene%20with%20a%20couple%20sharing%20a%20gentle%20kiss%20near%20a%20sunlit%20window%2C%20warm%20morning%20light%2C%20soft%20pastel%20tones%2C%20lifestyle%20photography%2C%20clean%20warm%20background&width=640&height=360&seq=qz-v3&orientation=landscape",
    duration: "02:48",
    uploadedAt: "2026-09-15",
    categoryKey: "emotional",
    region: "中国",
    year: 2026,
    type: "短片",
    views: 76420,
    favorites: 5230,
    description:
      "一则关于日常温柔的情感短片：清晨的厨房里，忙碌的两人用一个轻轻的吻开启新的一天。没有对白，只有阳光与烟火气。",
    source: "情感短片《日常的温度》",
    tags: ["清晨", "日常", "治愈", "无对白"],
    specialIds: ["s3"],
  },
  {
    id: "v4",
    title: "毕业典礼上的惊喜拥抱",
    cover:
      "https://readdy.ai/api/search-image?query=Joyful%20outdoor%20graduation%20scene%20with%20a%20young%20couple%20hugging%20and%20kissing%20among%20cheering%20friends%20on%20a%20sunny%20campus%20lawn%2C%20vibrant%20warm%20daylight%2C%20bright%20optimistic%20tones%2C%20documentary%20style&width=640&height=360&seq=qz-v4&orientation=landscape",
    heroCover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20joyful%20couple%20embracing%20on%20a%20sunny%20campus%20lawn%20surrounded%20by%20blurred%20celebrating%20friends%2C%20bright%20warm%20daylight%2C%20golden%20tones%2C%20hopeful%20romantic%20mood%20with%20soft%20shadow%20contrast&width=1920&height=820&seq=qz-hero2&orientation=landscape",
    duration: "06:04",
    uploadedAt: "2026-09-08",
    categoryKey: "short",
    region: "中国",
    year: 2026,
    type: "短片",
    views: 64310,
    favorites: 3980,
    description:
      "毕业典礼上最热闹的一刻：在同学们的口号声中，两人相拥而吻。青春、欢呼与阳光被完整记录，是一段让人会心一笑的画面。",
    source: "校园短视频合集",
    tags: ["青春", "毕业", "校园", "欢快"],
    specialIds: ["s3"],
  },
  {
    id: "v5",
    title: "老电影院的最后一排",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20vintage%20cinema%20interior%20with%20a%20couple%20kissing%20in%20the%20back%20row%2C%20flickering%20projector%20light%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20retro%20film%20grain%2C%20romantic%20mood&width=640&height=360&seq=qz-v5&orientation=landscape",
    duration: "03:52",
    uploadedAt: "2026-08-30",
    categoryKey: "film",
    region: "欧美",
    year: 2024,
    type: "长片剪辑",
    views: 88720,
    favorites: 5640,
    description:
      "黑白光影里的浪漫：老电影院最后一排，投影的光在两人脸上流转。这一段几乎没有台词，全靠眼神与光影推动情绪。",
    source: "《光影之间》片段精选",
    tags: ["电影院", "怀旧", "黑白", "光影"],
    specialIds: ["s1"],
  },
  {
    id: "v6",
    title: "海边落日的第一次牵手",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20beach%20sunset%20scene%20with%20a%20couple%20holding%20hands%20and%20kissing%20by%20shallow%20water%2C%20glowing%20orange%20and%20pink%20sky%2C%20gentle%20waves%2C%20soft%20romantic%20cinematic%20tones&width=640&height=360&seq=qz-v6&orientation=landscape",
    duration: "04:40",
    uploadedAt: "2026-08-22",
    categoryKey: "emotional",
    region: "日本",
    year: 2025,
    type: "短片",
    views: 71380,
    favorites: 4760,
    description:
      "海边落日的温柔时刻：从试探性地牵手到自然的亲吻，画面被暮色染成暖橘色。适合在安静的夜晚慢慢看完。",
    source: "情感短片《潮汐》",
    tags: ["海边", "落日", "牵手", "温柔"],
    specialIds: ["s1", "s3"],
  },
  {
    id: "v7",
    title: "雪夜路灯下的重逢",
    cover:
      "https://readdy.ai/api/search-image?query=Winter%20night%20scene%20of%20a%20couple%20reuniting%20and%20kissing%20under%20a%20glowing%20streetlamp%20as%20snow%20falls%2C%20warm%20amber%20light%20against%20cool%20blue%20snow%2C%20cozy%20romantic%20cinematic%20mood&width=640&height=360&seq=qz-v7&orientation=landscape",
    heroCover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20couple%20reuniting%20under%20a%20glowing%20streetlamp%20in%20falling%20snow%20at%20night%2C%20warm%20amber%20light%20against%20cool%20dusk%20tones%2C%20soft%20haze%2C%20romantic%20film%20grade&width=1920&height=820&seq=qz-hero3&orientation=landscape",
    duration: "07:20",
    uploadedAt: "2026-08-14",
    categoryKey: "film",
    region: "欧美",
    year: 2023,
    type: "长片剪辑",
    views: 105900,
    favorites: 7020,
    description:
      "阔别多年的两人在雪夜的路灯下重逢，迟疑片刻后相拥而吻。冷冽的雪色与温暖的路灯光形成强烈对比，是本片最经典的一幕。",
    source: "《冬夜来信》片段精选",
    tags: ["雪夜", "重逢", "路灯", "冬季"],
    specialIds: ["s2"],
  },
  {
    id: "v8",
    title: "地铁口的偶遇",
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20street%20scene%20of%20a%20couple%20sharing%20a%20quick%20kiss%20at%20a%20subway%20entrance%20during%20busy%20rush%20hour%2C%20warm%20evening%20city%20lights%2C%20shallow%20depth%20of%20field%2C%20lifestyle%20tones&width=640&height=360&seq=qz-v8&orientation=landscape",
    duration: "01:58",
    uploadedAt: "2026-08-05",
    categoryKey: "short",
    region: "中国",
    year: 2024,
    type: "短片",
    views: 52910,
    favorites: 3140,
    description:
      "人流匆匆的地铁口，他们只用一个短暂的吻道别。短短两分钟，却把都市里那种来不及说再见的情绪表达得刚刚好。",
    source: "都市短视频合集",
    tags: ["都市", "偶遇", "地铁", "日常"],
    specialIds: ["s3"],
  },
  {
    id: "v9",
    title: "樱花树下的告白",
    cover:
      "https://readdy.ai/api/search-image?query=Spring%20scene%20of%20a%20couple%20kissing%20beneath%20blooming%20cherry%20blossom%20trees%2C%20pink%20petals%20drifting%20in%20soft%20sunlight%2C%20pastel%20romantic%20tones%2C%20dreamy%20cinematic%20photography&width=640&height=360&seq=qz-v9&orientation=landscape",
    duration: "05:10",
    uploadedAt: "2026-07-28",
    categoryKey: "film",
    region: "日本",
    year: 2025,
    type: "长片剪辑",
    views: 119300,
    favorites: 7890,
    description:
      "樱花纷飞的午后，一句迟到的告白终于说出口。漫天的花瓣与轻柔的风把这一幕拍得格外浪漫，是樱花季必看的经典片段。",
    source: "《花见》片段精选",
    tags: ["樱花", "告白", "春天", "浪漫"],
    specialIds: ["s1", "s3"],
  },
  {
    id: "v10",
    title: "加班夜晚的无声陪伴",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20late%20night%20office%20or%20home%20desk%20scene%20with%20a%20tired%20couple%20sharing%20a%20gentle%20comforting%20kiss%2C%20single%20warm%20desk%20lamp%20glow%2C%20intimate%20cozy%20low%20light%2C%20film%20tones&width=640&height=360&seq=qz-v10&orientation=landscape",
    duration: "03:26",
    uploadedAt: "2026-07-19",
    categoryKey: "emotional",
    region: "中国",
    year: 2025,
    type: "短片",
    views: 47820,
    favorites: 2980,
    description:
      "深夜的台灯下，加班的她抬起头，等来一个安静的吻。没有华丽的场景，却讲出了陪伴最真实的模样。",
    source: "情感短片《陪伴》",
    tags: ["深夜", "陪伴", "治愈", "日常"],
    specialIds: ["s2"],
  },
  {
    id: "v11",
    title: "摩天轮顶端的告白吻",
    cover:
      "https://readdy.ai/api/search-image?query=Fairground%20scene%20of%20a%20couple%20kissing%20inside%20a%20ferris%20wheel%20cabin%20at%20dusk%2C%20city%20skyline%20lights%20below%2C%20warm%20pink%20sunset%20tones%2C%20romantic%20cinematic%20mood&width=640&height=360&seq=qz-v11&orientation=landscape",
    duration: "04:58",
    uploadedAt: "2026-07-08",
    categoryKey: "emotional",
    region: "韩国",
    year: 2024,
    type: "短片",
    views: 88210,
    favorites: 6230,
    description:
      "摩天轮缓缓升到最高点，城市灯火在脚下铺开。他们在这里说出了那句话，也在这里留下了第一个吻。",
    source: "情感短片《最高点》",
    tags: ["摩天轮", "告白", "夜景", "浪漫"],
    specialIds: ["s1"],
  },
  {
    id: "v12",
    title: "校园走廊的擦肩与回眸",
    cover:
      "https://readdy.ai/api/search-image?query=Sunlit%20school%20corridor%20scene%20with%20a%20shy%20young%20couple%20exchanging%20a%20quick%20bashful%20kiss%2C%20warm%20afternoon%20light%20through%20windows%2C%20soft%20nostalgic%20pastel%20tones&width=640&height=360&seq=qz-v12&orientation=landscape",
    duration: "02:14",
    uploadedAt: "2026-06-26",
    categoryKey: "short",
    region: "日本",
    year: 2023,
    type: "短片",
    views: 55240,
    favorites: 3410,
    description:
      "青春校园里最心动的一幕：走廊拐角的一次擦肩，回头时四目相对，一个仓促又羞涩的吻定格了整个夏天。",
    source: "校园短视频合集",
    tags: ["校园", "青春", "羞涩", "夏天"],
    specialIds: ["s3"],
  },
  {
    id: "v13",
    title: "婚礼散场后的独处时光",
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20wedding%20venue%20after%20party%20with%20a%20newlywed%20couple%20sharing%20a%20quiet%20private%20kiss%2C%20warm%20string%20lights%20and%20candles%2C%20soft%20golden%20glow%2C%20intimate%20cinematic%20tones&width=640&height=360&seq=qz-v13&orientation=landscape",
    duration: "06:30",
    uploadedAt: "2026-06-15",
    categoryKey: "film",
    region: "欧美",
    year: 2022,
    type: "长片剪辑",
    views: 96430,
    favorites: 6870,
    description:
      "婚礼散场，喧嚣褪去后，新婚的两人在空荡的场地里相视一笑，然后一个安静的吻。全片用暖金色的灯串营造出梦幻氛围。",
    source: "《誓言》片段精选",
    tags: ["婚礼", "浪漫", "暖光", "幸福"],
    specialIds: ["s1"],
  },
  {
    id: "v14",
    title: "图书馆里的悄悄一吻",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20library%20scene%20with%20a%20couple%20stealing%20a%20secret%20kiss%20between%20tall%20bookshelves%2C%20warm%20soft%20window%20light%2C%20dust%20motes%20in%20the%20air%2C%20quiet%20romantic%20mood&width=640&height=360&seq=qz-v14&orientation=landscape",
    duration: "03:40",
    uploadedAt: "2026-06-03",
    categoryKey: "short",
    region: "中国",
    year: 2023,
    type: "短片",
    views: 44120,
    favorites: 2760,
    description:
      "高大的书架之间，指尖同时碰到同一本书。抬头的那一瞬间，两人都笑了，也悄悄靠近。",
    source: "都市短视频合集",
    tags: ["图书馆", "安静", "书卷气", "邂逅"],
    specialIds: ["s3"],
  },
  {
    id: "v15",
    title: "机场到达口的久别重逢",
    cover:
      "https://readdy.ai/api/search-image?query=Emotional%20airport%20arrival%20hall%20reunion%20scene%20with%20a%20couple%20running%20into%20each%20others%20arms%20and%20kissing%2C%20warm%20indoor%20lighting%2C%20blurred%20moving%20crowd%2C%20hopeful%20cinematic%20tones&width=640&height=360&seq=qz-v15&orientation=landscape",
    duration: "05:52",
    uploadedAt: "2026-05-21",
    categoryKey: "emotional",
    region: "韩国",
    year: 2022,
    type: "短片",
    views: 81230,
    favorites: 5720,
    description:
      "分隔两地许久，终于在机场到达口重逢。行李散落一地，两人紧紧拥抱，那个吻里有等待也有终于放下的安心。",
    source: "情感短片《抵达》",
    tags: ["机场", "重逢", "久别", "感动"],
    specialIds: ["s2"],
  },
  {
    id: "v16",
    title: "老屋天台的星空之吻",
    cover:
      "https://readdy.ai/api/search-image?query=Night%20rooftop%20scene%20of%20a%20couple%20kissing%20under%20a%20starry%20sky%20on%20an%20old%20building%20terrace%2C%20warm%20fairy%20lights%20and%20city%20glow%20in%20distance%2C%20deep%20blue%20night%20with%20warm%20highlights%2C%20dreamy%20cinematic%20mood&width=640&height=360&seq=qz-v16&orientation=landscape",
    duration: "04:16",
    uploadedAt: "2026-05-09",
    categoryKey: "emotional",
    region: "日本",
    year: 2021,
    type: "短片",
    views: 62340,
    favorites: 4090,
    description:
      "老屋的天台上，串灯与星空在头顶亮起。两人并肩而坐，聊着聊着就靠得更近，最后交换了一个被星光包裹的吻。",
    source: "情感短片《天台》",
    tags: ["星空", "天台", "夜晚", "温柔"],
    specialIds: ["s3"],
  },
];

export const specials: Special[] = [
  {
    id: "s1",
    title: "银幕经典之吻",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20collage%20style%20cinematic%20poster%20of%20classic%20romantic%20film%20kiss%20moments%2C%20warm%20rose%20and%20amber%20film%20tones%2C%20soft%20bokeh%20lights%2C%20vintage%20cinema%20atmosphere%2C%20highly%20detailed&width=800&height=400&seq=qz-sp1&orientation=landscape",
    intro:
      "盘点那些被反复回味的银幕亲吻瞬间，从花田到电影院，从婚礼到雪夜，每一帧都是电影史上的经典。",
    reason:
      "影视里的亲吻往往不只是一个动作，而是整段故事的情绪出口。本专题按场景与情绪整理，帮你在最短时间里找到最动人的那几幕。",
    videoIds: ["v1", "v5", "v9", "v13", "v11", "v6"],
  },
  {
    id: "s2",
    title: "雨中的告白",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20poster%20of%20romantic%20rainy%20confession%20scenes%2C%20wet%20streets%20with%20glowing%20reflections%2C%20warm%20lantern%20light%20against%20moody%20gray%20tones%2C%20emotional%20and%20intimate%20mood&width=800&height=400&seq=qz-sp2&orientation=landscape",
    intro:
      "雨总能让感情变得更浓。这组作品收录了雨夜、站台与深夜场景里的亲吻，潮湿的空气里有说不出口的话。",
    reason:
      "雨天自带天然的情绪滤镜，画面里的水光与灯光让人物更专注、氛围更浓。喜欢克制又深情的表达一定要看这一组。",
    videoIds: ["v2", "v7", "v10", "v15"],
  },
  {
    id: "s3",
    title: "治愈系温柔瞬间",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20warm%20poster%20of%20gentle%20everyday%20romantic%20moments%2C%20cozy%20light%20and%20pastel%20tones%2C%20sunlit%20intimate%20scenes%2C%20calm%20comforting%20aesthetic%2C%20highly%20detailed&width=800&height=400&seq=qz-sp3&orientation=landscape",
    intro:
      "不需要轰轰烈烈，日常里的一个轻吻就足够温暖。这一组合集偏向清新治愈，适合在疲惫的时候慢慢看。",
    reason:
      "温柔的瞬间最能长久地留在记忆里。本组挑选阳光、清晨与日常场景，用最轻的方式讲述陪伴。",
    videoIds: ["v3", "v4", "v6", "v8", "v12", "v14", "v16"],
  },
];

export const getVideosByCategory = (categoryKey: string): Video[] =>
  videos.filter((v) => v.categoryKey === categoryKey);

export const getVideoById = (id: string): Video | undefined =>
  videos.find((v) => v.id === id);

export const getSpecialById = (id: string): Special | undefined =>
  specials.find((s) => s.id === id);

export const getRelatedVideos = (video: Video, limit = 6): Video[] => {
  const sameCategory = videos.filter(
    (v) => v.id !== video.id && v.categoryKey === video.categoryKey
  );
  const sameSpecial = videos.filter(
    (v) =>
      v.id !== video.id &&
      v.specialIds.some((sid) => video.specialIds.includes(sid))
  );
  const merged = [...sameCategory, ...sameSpecial].filter(
    (v, i, arr) => arr.findIndex((x) => x.id === v.id) === i
  );
  const pool =
    merged.length >= limit
      ? merged
      : [...merged, ...videos.filter((v) => v.id !== video.id)].filter(
          (v, i, arr) => arr.findIndex((x) => x.id === v.id) === i
        );
  return pool.slice(0, limit);
};

export const formatViews = (n: number): string => {
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
};